import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';

const energyData = [
   {
      title: "COMPTES DE L'ENERGIE AU BURUNDI - 2022-2023",
      link: "/documents/energy/PUBLICATION_COMPTE_DE_ENERGIE_2022_2023.pdf",
      image: 'assets/energy/rapport.PNG',
      description: "Une augmentation de l’énergie totale extraite de l’environnement est observée, passant de 196 157,83 térajoules en 2022 à 207 286,89 térajoules en 2023. Cette énergie provient essentiellement de l’agriculture, sylviculture et pêche, dominée par le bois énergie (plus de 99 %).",
      date: "2026-03-18",
      publicationDate: "2026-03-18",
    },
    {
      title: "COMPTES DE L’ENERGIE AU BURUNDI – 2021",
      link: "/documents/energy/PUBLICATION-COMPTE-DE-LENERGIE-2021_Ambroise-1.pdf",
      image: 'assets/energy/rapport.PNG',
      description: "Une présentation des ressources totales d'energie de 36372,5 KJ/FBU contre 26745,1 KJ/FBU du 2020 avec une production de 20121674 KJ/FBU  et de l'importation nette 2,6 KJ/FBU.",
      date: "2021-12-20",
      publicationDate: "2023-12-24"
    },
    {
      title: "COMPTES DE L’ENERGIE AU BURUNDI – 2018-2020",
      link: "/documents/energy/PUBLICATION-COMPTE-DE-LENERGIE-20182019-et-2020-1.pdf",
      image: 'assets/energy/statistiques.PNG',
      description: "Une présentation des ressources totales d'energie respective de 26709,6 KJ/FBU en 2018, 26834,2 KJ/FBU en 2019 et 26745,1 KJ/FBU en 2020.",
      date: "2020-12-01",
      publicationDate: "2023-02-24"
    }
];

function ComptesEnergie() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredEnergy, setFilteredEnergy] = useState(energyData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredEnergy(energyData);
    } else {
      const filtered = energyData.filter((entry) => {
        const entryYear = new Date(entry.date).getFullYear();
        return entryYear === parseInt(year);
      });
      setFilteredEnergy(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <br />
        <br />
   
        <Container maxWidth="lg" style={{ paddingTop: '24px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Comptes de l'Energie 
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les comptes de l'énergie fournissent une mesure détaillée de la production, de la consommation et des coûts de l'énergie, essentiels pour le développement durable et la planification énergétique.
          </Typography>

          <FormControl variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de publication"
            >
              <MenuItem value="Tous">Tous les rapports</MenuItem>
              {[...new Set(energyData.map((entry) => new Date(entry.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredEnergy.slice(0, visibleCount).map((entry, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a href={entry.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={entry.image}
                        alt={entry.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a href={entry.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                        {<DownloadIcon />}{entry.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" style={{ color: '#555', marginBottom: '10px' }}>
                        {entry.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(entry.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
            {visibleCount < filteredEnergy.length && (
              <Button
                onClick={handleShowMore}
                variant="contained"
                style={{
                  marginTop: '5px',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  marginBottom: '10px',
                }}
              >
                Plus de Rapports
              </Button>
            )}
          </Box>

          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les comptes de l'énergie sont publiés annuellement, fournissant des informations essentielles pour la planification énergétique et le développement durable.
          </Typography>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default ComptesEnergie;
